import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/profesores';
import ProfesoresList from './Profesores';


const ms2p = (state) => {
  return {
    ...state.profesores,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ProfesoresList);
